var map = {
	"./African.png": 192,
	"./All.png": 193,
	"./Bakers.png": 194,
	"./Bread.png": 195,
	"./Chinese .png": 196,
	"./Cookie.png": 197,
	"./Drinks.png": 198,
	"./Japanese.png": 199,
	"./Mexican.png": 200,
	"./Near Me.png": 201,
	"./Pastry.png": 202,
	"./Price.png": 203,
	"./Rice and Egg.png": 204,
	"./Thai.png": 205,
	"./carrot.svg": 206,
	"./chef.png": 207,
	"./cooking.png": 208,
	"./curry.png": 209,
	"./immediate.png": 210,
	"./indian.png": 211,
	"./italian .png": 212,
	"./now.svg": 213,
	"./price.svg": 214
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 215;